import React from 'react';
import './PaiementErreur.scss';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import {withTranslation} from 'react-i18next';

const PaiementErreur = ({t, erreur, onClose}) => {
  return (
    <div>
      <DialogTitle>{t('erreur')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{erreur}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button type="submit" color="primary" onClick={onClose}>
          {t('fermer')}
        </Button>
      </DialogActions>
    </div>
  );
};

export default withTranslation()(PaiementErreur);
